<template>
  <section>
    <div class="default-modal patient-popup">
      <el-dialog
        width="50%"
        align-center
        v-model="canvasVehiculo"
        @close="close"
        hide-overlay
      >
        <div class="dialog-header">
          <span class="header-part"> Add Physician Signature </span>
          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="canvasVehiculo = false"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
          /></el-button>
        </div>
        <div class="popup-date pb-0">
          <el-tabs
            v-model="activeName"
            @tab-click="updateSelectedTabQuery"
            :before-leave="checkActiveTab"
          >
            <!-- <el-tab-pane label="Upload Sign" name="image">
              <div class="attach-img">
                <img v-if="previewImage" :src="previewImage" />
              </div>
              <div class="attach-input">
                <el-button class="btn radius-button round-button">
                  <span>
                    <img
                      src="@/assets/images/icons/attachment-icon-v2.svg"
                      alt=""
                    /> </span
                  >Choose File</el-button
                >
                <input
                  type="file"
                  class="hide_file"
                  accept="image/*"
                  @change="uploadImage()"
                  ref="file"
                />
              </div>
            </el-tab-pane> -->
            <el-tab-pane label="Draw Sign" name="draw">
              <div>
                <div class="signature">
                  <VueSignaturePad
                    width="100%"
                    ref="physicianSignaturePad"
                    id="signature"
                  />
                </div>
                <div class="undo-btn">
                  <el-button
                    type="text"
                    class="clear-btn"
                    @click="undoPhysicianSign"
                    >Clear
                  </el-button>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="Type Sign" name="type" v-if="!isFacilityUser">
              <div class="type_signature">
                <div class="signature-fields">
                  <label for="text"> Select Text Style </label>
                  <el-select
                    v-model="selectedTextStyle"
                    style="width: auto"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="(font, index) of fontFamily"
                      :key="index"
                      :value="font.value"
                      :label="font.label"
                    ></el-option>
                  </el-select>
                  <label for="text"> Enter Signature </label>
                  <el-input
                    v-model="textInput"
                    placeholder="Enter Signature"
                    style="width: auto"
                  ></el-input>
                </div>
                <div>
                  <div class="signature">
                    <canvas
                      id="myCanvas"
                      width="250"
                      height="80"
                      style="border: 1px solid grey"
                    ></canvas>
                  </div>
                  <div class="undo-btn">
                    <el-button
                      type="text"
                      class="clear-btn"
                      @click="clearCanvas"
                      >Clear
                    </el-button>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>

          <div class="dialog-footer">
            <el-button class="cancel-button" @click="close">Cancel</el-button>
            <el-button class="blue-save-button" @click="saveSignature">
              Confirm
            </el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import VueSignaturePad from "vue3-signature-pad";
import { ElMessageBox } from "element-plus";
import caseConstants from "@/config/constants/caseConstants";

export default {
  components: {
    VueSignaturePad,
  },
  props: ["refreshSign"],
  data() {
    return {
      activeName: "draw",
      physicianSign: "",
      visible: true,
      canvasVehiculo: false,
      imageBaseUrl: "",
      previewImage: "",
      textInput: "",
      selectedTextStyle: "25px Roboto",
      fontFamily: caseConstants.fontStyles,
    };
  },
  computed: {
    isFacilityUser() {
      if (this.getAuthenticatedUser && this.getAuthenticatedUser.user_type) {
        let users = [
          "HOSPITAL_PHYSICIAN",
          "HOSPITAL_ADMIN",
          "HOSPITAL_ACCOUNT_MANAGER",
          "MARKETER",
          "HOSPITAL_MARKETING_MANAGER",
          "ACCOUNT_MANAGER"
        ];
        if (users.indexOf(this.getAuthenticatedUser.user_type) !== -1) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
  },
  methods: {
    clearCanvas() {
      const canvas = document.getElementById("myCanvas");
      const ctx = canvas.getContext("2d");
      // Clear the entire canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.textInput = "";
      this.physicianSign = "";
    },
    drawText() {
      if (this.textInput) {
        const canvas = document.getElementById("myCanvas");
        const ctx = canvas.getContext("2d");
        const { textInput, selectedTextStyle } = this;
        // Clear the canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Set font style based on selected option
        ctx.font = selectedTextStyle;
        // ctx.fillText(textInput, 10, 50);
        const maxLineWidth = 220; // Adjust this value as needed
        const lineHeight = 24; // Adjust this value as needed
        const x = 10;
        let y = 50;

        // Split the text into lines that fit within the canvas width
        const lines = this.wrapText(
          ctx,
          textInput,
          x,
          y,
          maxLineWidth,
          lineHeight
        );

        // Draw each line of text
        lines.forEach((line) => {
          ctx.fillText(line, x, y);
          y += lineHeight;
        });
        const base64String = canvas.toDataURL("image/png");
        this.physicianSign = base64String;
      }
    },
    wrapText(context, text, x, y, maxWidth, lineHeight) {
      const words = text.split(" ");
      const lines = [];
      let currentLine = words[0];

      for (let i = 1; i < words.length; i++) {
        const word = words[i];
        const testLine = currentLine + " " + word;
        const testWidth = context.measureText(testLine).width;

        if (testWidth <= maxWidth) {
          currentLine = testLine;
        } else {
          lines.push(currentLine);
          currentLine = word;
        }
      }

      lines.push(currentLine);
      return lines;
    },
    undoPhysicianSign() {
      this.$refs.physicianSignaturePad.undoSignature();
    },
    checkActiveTab(activeName, oldActiveName) {
      const { isEmpty, data } =
        this.$refs.physicianSignaturePad.saveSignature();
      if (!isEmpty && activeName == "type") {
        ElMessageBox.confirm(
          "Are you sure to clear the signature ?",
          "Warning",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        )
          .then(() => {
            this.$refs.physicianSignaturePad.clearSignature();
          })
          .catch(() => {
            this.activeName = "draw";
            this.updateSelectedTabQuery();
          });
      }
      // if (
      //   (activeName == "draw" || activeName == "type") &&
      //   this.$refs.file.value
      // ) {
      //   ElMessageBox.confirm(
      //     "Are you sure to clear clear the signature ?",
      //     "Warning",
      //     {
      //       confirmButtonText: "OK",
      //       cancelButtonText: "Cancel",
      //       type: "warning",
      //     }
      //   )
      //     .then(() => {
      //       this.removeImage();
      //     })
      //     .catch(() => {
      //       this.activeName = "image";
      //     });
      // }
      if (activeName == "draw" && this.textInput) {
        ElMessageBox.confirm(
          "Are you sure to clear the signature ?",
          "Warning",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        )
          .then(() => {
            this.clearCanvas();
          })
          .catch(() => {
            this.activeName = "type";
          });
      }
    },

    removeImage() {
      this.previewImage = "";
      this.$refs.file.value = "";
    },
    uploadImage() {
      const fi = document.querySelector("input[type=file]").files;
      // Check if any file is selected.

      if (fi.length > 0) {
        for (let i = 0; i <= fi.length - 1; i++) {
          const fsize = fi.item(i).size;
          const file = Math.round(fsize / 1024);
          // The size of the file.
          if (file >= 3072) {
            alert("File too Big, please select a file less than 3mb");
            this.removeImage();
          } else {
            const file = document.querySelector("input[type=file]").files[0];
            this.previewImage = URL.createObjectURL(file);
            const reader = new FileReader();

            let rawImg;
            reader.onloadend = () => {
              rawImg = reader.result;
              this.physicianSign = rawImg;
              this.imageBaseUrl = rawImg;
            };
            reader.readAsDataURL(file);
          }
        }
      }
    },
    close() {
      this.canvasVehiculo = false;
      this.$emit("close");
    },
    updateSelectedTabQuery() {
      this.canvasVehiculo = true;
      this.$nextTick(() => {
        this.$refs.physicianSignaturePad.resizeCanvas();
      });
    },
    saveSignature() {
      const { isEmpty, data } =
        this.$refs.physicianSignaturePad.saveSignature();
      if (!isEmpty) {
        this.physicianSign = data;
      }
      if (this.physicianSign) {
        this.$emit("physicianSignature", this.physicianSign);
      } else {
        this.$emit("close");
      }
      this.visible = false;
      this.canvasVehiculo = false;
    },
  },
  mounted() {
    // Load Google Fonts and then draw text
    Promise.all([
      document.fonts.load("1em Roboto"),
      document.fonts.load("1em Lato"),
      document.fonts.load("1em Alegreya"),
      document.fonts.load("1em Amatic SC"),
      document.fonts.load("1em Ubuntu"),
      document.fonts.load("1em Satisfy"),
      document.fonts.load("1em BhuTuka Expanded One"),
      document.fonts.load("1em Peralta"),
      document.fonts.load("1em BioRhyme Expanded"),
      // Add more fonts as needed
    ]).then(this.drawText);
  },
  watch: {
    refreshSign: {
      immediate: true,
      handler: function () {
        this.canvasVehiculo = true;
        this.$nextTick(() => {
          this.$refs.physicianSignaturePad.resizeCanvas();
        });
      },
    },
    textInput: "drawText",
    selectedTextStyle: "drawText",
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Alegreya:wght@600&family=Amatic+SC&family=BhuTuka+Expanded+One&family=BioRhyme+Expanded&family=Grenze+Gotisch:wght@600&family=Peralta&family=Playfair+Display:wght@500&family=Satisfy&family=Ubuntu:wght@500&display=swap");
</style>
